@use 'sass:string';

$pink: (
  'lighten-4': #ffeaf4,
  'lighten-3': #ffd5e9,
  'lighten-2': #ff97c8,
  'lighten-1': #ff6db3,
  'base': #ff2f92,
  'darken-1': #e6006d,
  'darken-2': #ca2573,
);
$blue: (
  'lighten-4': #ebf7ff,
  'lighten-3': #cceaff,
  'lighten-2': #80caff,
  'lighten-1': #4cb6ff,
  'base': #0096ff,
  'darken-1': #006cb7,
);
$teal: (
  'lighten-4': #e1f3f5,
  'lighten-3': #b3e1e7,
  'lighten-2': #80cdd7,
  'lighten-1': #4ebac7,
  'base': #029caf,
  'darken-1': #067c8a,
);
$mustard: (
  'lighten-4': #fef1d9,
  'lighten-3': #fce2b2,
  'lighten-2': #facf80,
  'lighten-1': #f8bc4d,
  'base': #f59f00,
  'darken-1': #d78f0a,
);
$orange: (
  'lighten-4': #fdeee7,
  'lighten-3': #fbd4c3,
  'lighten-2': #f7b79b,
  'lighten-1': #f59a74,
  'base': #f06f38,
  'darken-1': #d94100,
);
$grey: (
  'lighten-6': #f9f9f9,
  'lighten-5': #f9fafb,
  'lighten-4': #f1f3f4,
  'lighten-3': #dbdfe1,
  'lighten-2': #cdd1d6,
  'lighten-1': #b1b8be,
  'base': #2d2f33,
  'darken-1': #484d51,
);
$green: (
  'lighten-1': #e8f7da,
  'base': #52a003,
);
$red: (
  'lighten-1': #ffe8e8,
  'base': #ff1b1b,
);
$shades: (
  'black': #000000,
  'white': #ffffff,
);
$branding: (
  'facebook': #3b5998,
  'linkedin': #0072b1,
  'twitter': #00acee,
  'instagram': #c13584,
  'google': #f34a38,
);

$theme-colors: (
  'pink': $pink,
  'blue': $blue,
  'teal': $teal,
  'mustard': $mustard,
  'orange': $orange,
  'grey': $grey,
  'green': $green,
  'red': $red,
  'shades': $shades,
  'branding': $branding,
);

:export {
  @each $color, $value in $theme-colors {
    @each $key, $value in $value {
      #{string.unquote($color + '--' + $key)}: $value;
    }
  }
}
